// import analytics from '../lib/analytics';
import {getHomeworkInfo} from '../lib/homework-info';

const OPEN_MODAL = 'scratch-gui/modals/OPEN_MODAL';
const CLOSE_MODAL = 'scratch-gui/modals/CLOSE_MODAL';
const SET_ITEM_VALUE = 'scratch-gui/modals/setItemValue';

const MODAL_BACKDROP_LIBRARY = 'backdropLibrary';
const MODAL_CAMERA_CAPTURE = 'cameraCapture';
const MODAL_COSTUME_LIBRARY = 'costumeLibrary';
const MODAL_EXTENSION_LIBRARY = 'extensionLibrary';
const MODAL_IMPORT_INFO = 'importInfo';
const MODAL_LOADING_PROJECT = 'loadingProject';
const MODAL_PREVIEW_INFO = 'previewInfo';
const MODAL_MASK_LAYER = 'maskLayer';
const MODAL_SOUND_LIBRARY = 'soundLibrary';
const MODAL_SPRITE_LIBRARY = 'spriteLibrary';
const MODAL_SOUND_RECORDER = 'soundRecorder';
const MODAL_LOGIN_INFO = 'loginInfo';
const MODAL_ASSET = 'asset';
const MODAL_PAINT_EDITOR = 'paintEditor';
const MODAL_SOUND_EDITOR = 'soundEditor';
const MODAL_TIPS_LIBRARY = 'tipsLibrary';
const MODAL_UPLOAD_HOMEWORK_PROGRESS = 'uploadHomeworkProgress';
const MODAL_UPLOAD_HOMEWORK_PROGRESS_NUM = 'uploadHomeworkProgressNum';
const MODAL_HOMEWORK_SUBMITING = 'homeworkSubmiting';
const MODAL_FINISH_HOMEWORK = 'finishHomework';
const MODAL_HOMEWORK_QRCODE_URL = 'homeworkQrcodeUrl';
const MODAL_VIDEO_GUIDE = 'videoGuide';
const MODAL_BACK_WITHOUT_SUBMIT = 'backWithoutSubmit';
const MODAL_SUBMIT_COMMENT_MODAL = 'submitCommentModal';
const WHITE_LIST = 'whiteList';

const initialState = {
    [MODAL_BACKDROP_LIBRARY]: false,
    [MODAL_CAMERA_CAPTURE]: false,
    [MODAL_COSTUME_LIBRARY]: false,
    [MODAL_EXTENSION_LIBRARY]: false,
    [MODAL_IMPORT_INFO]: false,
    [MODAL_LOADING_PROJECT]: false,
    [MODAL_PREVIEW_INFO]: false,
    [MODAL_MASK_LAYER]: !window.localStorage.maskLayerInited,
    [MODAL_SOUND_LIBRARY]: false,
    [MODAL_SPRITE_LIBRARY]: false,
    [MODAL_SOUND_RECORDER]: false,
    [MODAL_LOGIN_INFO]: false,
    [MODAL_TIPS_LIBRARY]: false,
    [MODAL_UPLOAD_HOMEWORK_PROGRESS]: false,
    [MODAL_UPLOAD_HOMEWORK_PROGRESS_NUM]: 0,
    [MODAL_FINISH_HOMEWORK]: false,
    [MODAL_ASSET]: false,
    [MODAL_PAINT_EDITOR]: false,
    [MODAL_SOUND_EDITOR]: false,
    [MODAL_HOMEWORK_QRCODE_URL]: '',
    [MODAL_VIDEO_GUIDE]: false,
    [MODAL_SUBMIT_COMMENT_MODAL]: false,
    [MODAL_BACK_WITHOUT_SUBMIT]: false,
    [MODAL_HOMEWORK_SUBMITING]: false,
    [WHITE_LIST]: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true
        });
    case CLOSE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    case SET_ITEM_VALUE:
        return Object.assign({}, state, {
            [action.target]: action.value
        });
    default:
        return state;
    }
};
const openModal = function (modal) {
    const homeworkInfo = getHomeworkInfo();
    const courseId = Number(homeworkInfo.courseId);
    const unitId = Number(homeworkInfo.unitId);
    const lessonId = Number(homeworkInfo.lessonId);
    switch (modal) {
    case 'backdropLibrary':
        ht.track('s3_stage_backdrop_choose', {
            context: {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            }
        });
        break;
    case 'costumeLibrary':
        ht.track('s3_sprite_costume_choose', {
            context: {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            }
        });
        break;
    case 'soundLibrary':
        ht.track('s3_sound_choose', {
            context: {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            }
        });
        break;
    case 'soundRecorder':
        ht.track('s3_sound_record', {
            context: {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            }
        });
        break;
    default:
        '';
    }
    return {
        type: OPEN_MODAL,
        modal: modal
    };
};
const closeModal = function (modal) {
    return {
        type: CLOSE_MODAL,
        modal: modal
    };
};
const openBackdropLibrary = function () {
    // analytics.pageview('/libraries/backdrops');
    return openModal(MODAL_BACKDROP_LIBRARY);
};
const openCameraCapture = function () {
    // analytics.pageview('/modals/camera');
    return openModal(MODAL_CAMERA_CAPTURE);
};
const openCostumeLibrary = function () {
    // analytics.pageview('/libraries/costumes');
    return openModal(MODAL_COSTUME_LIBRARY);
};
const openExtensionLibrary = function () {
    // analytics.pageview('/libraries/extensions');
    return openModal(MODAL_EXTENSION_LIBRARY);
};
const openHomeworkUploadProgress = function () {
    return openModal(MODAL_UPLOAD_HOMEWORK_PROGRESS);
};
const openFinishHomeworkLayer = function () {
    return openModal(MODAL_FINISH_HOMEWORK);
};
const openImportInfo = function () {
    // analytics.pageview('modals/import');
    return openModal(MODAL_IMPORT_INFO);
};
const openLoadingProject = function () {
    // analytics.pageview('modals/loading');
    return openModal(MODAL_LOADING_PROJECT);
};
const openPreviewInfo = function () {
    // analytics.pageview('/modals/preview');
    return openModal(MODAL_PREVIEW_INFO);
};
const openMaskLayer = function () {
    return openModal(MODAL_MASK_LAYER);
};
const openSoundLibrary = function () {
    // analytics.pageview('/libraries/sounds');
    return openModal(MODAL_SOUND_LIBRARY);
};
const openSpriteLibrary = function () {
    // analytics.pageview('/libraries/sprites');
    return openModal(MODAL_SPRITE_LIBRARY);
};
const openSoundRecorder = function () {
    // analytics.pageview('/modals/microphone');
    return openModal(MODAL_SOUND_RECORDER);
};
const openLogin = function () {
    return openModal(MODAL_LOGIN_INFO);
};
const openAsset = function () {
    return openModal(MODAL_ASSET);
};
const openPaintEditor = function () {
    return openModal(MODAL_PAINT_EDITOR);
};
const openSoundEditor = function () {
    return openModal(MODAL_SOUND_EDITOR);
};
const openTipsLibrary = function () {
    // analytics.pageview('/modals/tips');
    return openModal(MODAL_TIPS_LIBRARY);
};
const openVideoGuide = function () {
    // analytics.pageview('/modals/tips');
    return openModal(MODAL_VIDEO_GUIDE);
};
const openWhiteList = function () {
    return openModal(WHITE_LIST);
};

const openBackWithoutSubmit = function (){
    return openModal(MODAL_BACK_WITHOUT_SUBMIT);
};
const openSubmitCommentModal = function () {
    return openModal(MODAL_SUBMIT_COMMENT_MODAL);
};

const closeBackdropLibrary = function () {
    return closeModal(MODAL_BACKDROP_LIBRARY);
};
const closeCameraCapture = function () {
    return closeModal(MODAL_CAMERA_CAPTURE);
};
const closeCostumeLibrary = function () {
    return closeModal(MODAL_COSTUME_LIBRARY);
};
const closeExtensionLibrary = function () {
    return closeModal(MODAL_EXTENSION_LIBRARY);
};
const closeHomeworkUploadProgress = function () {
    return closeModal(MODAL_UPLOAD_HOMEWORK_PROGRESS);
};
const closeFinishHomeworkLayer = function () {
    return closeModal(MODAL_FINISH_HOMEWORK);
};
const closeImportInfo = function () {
    return closeModal(MODAL_IMPORT_INFO);
};
const closeLoadingProject = function () {
    return closeModal(MODAL_LOADING_PROJECT);
};
const closePreviewInfo = function () {
    return closeModal(MODAL_PREVIEW_INFO);
};
const closeMaskLayer = function () {
    return closeModal(MODAL_MASK_LAYER);
};
const closeSpriteLibrary = function () {
    return closeModal(MODAL_SPRITE_LIBRARY);
};
const closeSoundLibrary = function () {
    return closeModal(MODAL_SOUND_LIBRARY);
};
const closeSoundRecorder = function () {
    return closeModal(MODAL_SOUND_RECORDER);
};
const closeLogin = function () {
    return closeModal(MODAL_LOGIN_INFO);
};
const closeAsset = function () {
    return closeModal(MODAL_ASSET);
};
const closeTipsLibrary = function () {
    return closeModal(MODAL_TIPS_LIBRARY);
};
const closePaintEditor = function () {
    return closeModal(MODAL_PAINT_EDITOR);
};
const closeSoundEditor = function () {
    return closeModal(MODAL_SOUND_EDITOR);
};
const closeVideoGuide = function () {
    // analytics.pageview('/modals/tips');
    return closeModal(MODAL_VIDEO_GUIDE);
};
const closeBackWithoutSubmit = function (){
    return closeModal(MODAL_BACK_WITHOUT_SUBMIT);
};
const closeSubmitCommentModal = function () {
    return closeModal(MODAL_SUBMIT_COMMENT_MODAL);
};
const closeWhiteList = function () {
    return closeModal(WHITE_LIST);
};

const setItemValue = function (target, value) {
    return {
        type: SET_ITEM_VALUE,
        target: target,
        value: value
    };
};
const setHomeworkProgressNum = function (value) {
    return setItemValue(MODAL_UPLOAD_HOMEWORK_PROGRESS_NUM, value);
};
const setHomeworkQrcodeUrl = function (value) {
    return setItemValue(MODAL_HOMEWORK_QRCODE_URL, value);
};
const setSubmitingHomework = function (bool){
    return setItemValue(MODAL_HOMEWORK_SUBMITING, bool);
};

const loginModalOpen = state => state.scratchGui.modals[MODAL_LOGIN_INFO];


export {
    reducer as default,
    initialState as modalsInitialState,
    openBackdropLibrary,
    openCameraCapture,
    openCostumeLibrary,
    openExtensionLibrary,
    openHomeworkUploadProgress,
    openFinishHomeworkLayer,
    openImportInfo,
    openLoadingProject,
    openPreviewInfo,
    openMaskLayer,
    openSoundLibrary,
    openSpriteLibrary,
    openSoundRecorder,
    openLogin,
    openAsset,
    openPaintEditor,
    openSoundEditor,
    openTipsLibrary,
    openVideoGuide,
    openWhiteList,
    openBackWithoutSubmit,
    openSubmitCommentModal,
    closeBackdropLibrary,
    closeCameraCapture,
    closeCostumeLibrary,
    closeExtensionLibrary,
    closeHomeworkUploadProgress,
    closeFinishHomeworkLayer,
    closeImportInfo,
    closeLoadingProject,
    closePreviewInfo,
    closeMaskLayer,
    closeSpriteLibrary,
    closeSoundLibrary,
    closeSoundRecorder,
    closeLogin,
    closeAsset,
    closePaintEditor,
    closeSoundEditor,
    closeTipsLibrary,
    closeVideoGuide,
    closeWhiteList,
    closeBackWithoutSubmit,
    closeSubmitCommentModal,
    loginModalOpen,
    setHomeworkProgressNum,
    setHomeworkQrcodeUrl,
    setSubmitingHomework
};
